import React, { useState, useEffect } from 'react';
import logo from '../../assets/logo.png';
import OptimizedImage from '../optimizedImage/optimizedImage';
import { Link, useLocation } from 'react-router-dom';
import './header.scss';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`patio-purpura-header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <Link to="/" onClick={closeMobileMenu}>
          <OptimizedImage 
            src={logo}
            alt="Patio Púrpura Logo" 
            className="patio-purpura-header-logo" 
            priority={true}
            sizes="150px"
          />
        </Link>

        <div className={`main-menu ${isMobileMenuOpen ? 'open' : ''}`}>
          <Link 
            to="/" 
            className={location.pathname === '/' ? 'active' : ''}
            onClick={closeMobileMenu}
          >
            Inicio
          </Link>
          <Link 
            to="/contactenos" 
            className={location.pathname === '/contactenos' ? 'active' : ''}
            onClick={closeMobileMenu}
          >
            Contáctenos
          </Link>
        </div>

        <div className="business-hours">
          <span className="hours-text">
            Pedidos: Antes del Martes | Entrega: Jueves-Viernes
          </span>
        </div>

        <button 
          className={`mobile-menu-toggle ${isMobileMenuOpen ? 'open' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
}

export default Header;
